var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from "classnames";
import { CSIcon } from '~icons/rankingList/CSIcon';
import { Currency } from '~atoms';
import { useIsDesktop } from "~hooks";
import CSCoin from "~icons/balance/CS_Coin.svg";
import { formatLargeNumber } from "~utils/formatLargeNumber";
import { numberWithDots } from "~utils/numberWithDots";
import { initializeAvatarStyles } from "~pages/ranking-list/constants";
import { useStyles } from './UserCardCartoon.styles';
var mainPath = process.env.REACT_CDN_ORIGIN || '';
export var UserCardCartoon = function (_a) {
    var avatar = _a.avatar, avatarUrl = _a.avatarUrl, avatarBackgroundUrl = _a.avatarBackgroundUrl, balance = _a.balance, level = _a.level, rank = _a.rank, _b = _a.currency, currency = _b === void 0 ? 'CRD' : _b, background = _a.background, extraClass = _a.extraClass, isGlobalRanking = _a.isGlobalRanking, isGroupRanking = _a.isGroupRanking, isRankingListEmpty = _a.isRankingListEmpty, showJoinGameModal = _a.showJoinGameModal;
    var t = useTranslation('tip-game').t;
    var classes = useStyles();
    var isDesktop = useIsDesktop();
    var userAvatar = avatar === null || avatar === void 0 ? void 0 : avatar.toLowerCase();
    var avatarStyles = initializeAvatarStyles(t);
    var userStyle = userAvatar ? avatarStyles[userAvatar] : null;
    var backgroundUrl = avatarBackgroundUrl ? "url(".concat(mainPath).concat(avatarBackgroundUrl, ")") : '';
    var backgroundStyles = {
        backgroundImage: backgroundUrl,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 20px center',
        backgroundSize: 'auto 100%',
    };
    var currencyIcon = isGlobalRanking
        ? React.createElement("img", { src: CSCoin, alt: 'coin' })
        : currency === 'CRD'
            ? React.createElement(CSIcon, { size: "sm", color: '#6CFF00' })
            : React.createElement(Currency, { currency: currency });
    var balanceValue = isGlobalRanking ? formatLargeNumber(balance || 0) : numberWithDots(balance || 0);
    var hasNotPlayed = !balance && !level && !rank;
    var renderLevelBlock = function () {
        if (hasNotPlayed) {
            return React.createElement("span", { className: classes.noneTextTransform }, t('ranking-list.not_played'));
        }
        if (isGlobalRanking) {
            return React.createElement("span", null, level ? "".concat(t('rank'), " ").concat(level) : '');
        }
        if (isRankingListEmpty) {
            return React.createElement("span", { className: classes.noneTextTransform }, t('coming_soon'));
        }
        if (isGroupRanking) {
            return level ? React.createElement("span", { className: classes.noneTextTransform }, "".concat(t('rank'), " ").concat(level)) : React.createElement("span", { className: classes.noneTextTransform }, t('join_the_game'));
        }
        return level ? React.createElement("span", null, "".concat(t('level'), " ").concat(level)) : React.createElement("span", { className: classes.noneTextTransform }, t('join_the_game'));
    };
    var isJoinGameButton = !hasNotPlayed && !isGlobalRanking && !isRankingListEmpty && !level;
    var onCardClick = function () {
        if (isJoinGameButton && showJoinGameModal) {
            showJoinGameModal();
        }
    };
    return (React.createElement("div", { role: "button", tabIndex: 0, className: classNames(classes.backgroundWrapper, !isDesktop && classes.mt108, extraClass), style: { background: background }, onClick: onCardClick },
        React.createElement("div", { className: classes.backgroundTop }),
        React.createElement("div", { className: classes.wrapper, style: __assign({}, backgroundStyles) },
            React.createElement("div", { className: classes.avatar },
                React.createElement("img", { src: avatarUrl ? "".concat(mainPath).concat(avatarUrl) : '', alt: 'user avatar' }),
                React.createElement("span", null, userStyle === null || userStyle === void 0 ? void 0 : userStyle.avatarName)),
            React.createElement("div", { className: classes.content },
                React.createElement("div", { className: classNames(classes.level, isGlobalRanking && classes.rank) }, renderLevelBlock()),
                React.createElement("div", { className: classes.divider }),
                React.createElement("div", { className: classes.myCredits }, (balance || balance === 0) && (React.createElement(React.Fragment, null,
                    React.createElement("span", null, isGlobalRanking ? t('ranking-list.status_credits') : !level ? t('bonus_amount') : t('ranking-list.my_credits')),
                    React.createElement("span", { className: classes.balance },
                        balanceValue,
                        currencyIcon))))))));
};
